export const operators = ['All', 'TIGO', 'VODACOM', 'AIRTEL', 'HALOTEL'];